import { colors } from '@coverflex-tech/hypernova-design-tokens';

export const TEXT_COLORS = colors.light.semantic.text;
export const SURFACE_COLORS = colors.light.semantic.surface;
